const GUEST_STORAGE_KEY = 'guest';

const dataOrDefault = (data, defaultValue) =>
  (data === null || typeof data === 'undefined') && typeof defaultValue !== 'undefined' ? defaultValue : data;

export const readStorage = (type, name, defaultValue, raw = false) => {
  try {
    const rawData = window[type].getItem(name);
    const data = raw ? rawData : JSON.parse(rawData);
    return dataOrDefault(data, defaultValue);
  } catch (e) {
    return defaultValue;
  }
};

export const readStorageForUser = (type, name, userId, defaultValue) => {
  const data = readStorage(type, name, {})[userId || GUEST_STORAGE_KEY];
  return dataOrDefault(data, defaultValue);
};

export const writeStorage = (type, name, data, raw = false) => {
  try {
    window[type].setItem(name, raw ? data : JSON.stringify(data));
  } catch (e) {
    /* noop */
  }
};

export const writeStorageForUser = (type, name, data, userId) =>
  writeStorage(type, name, {
    ...readStorage(type, name, {}),
    [userId || GUEST_STORAGE_KEY]: data,
  });

export const removeStorage = (type, name) => {
  try {
    window[type].removeItem(name);
  } catch (e) {
    /* noop */
  }
};

export const removeStorageForUser = (type, name, userId) => {
  const data = readStorage(type, name, {});
  delete data[userId || GUEST_STORAGE_KEY];
  if (Object.keys(data) === 0) {
    removeStorage(type, name);
  } else {
    writeStorage(type, name, data);
  }
};

const LOCAL = 'localStorage';
const SESSION = 'sessionStorage';

export const readLocalStorage = readStorage.bind(null, LOCAL);
export const readLocalStorageForUser = readStorageForUser.bind(null, LOCAL);
export const writeLocalStorage = writeStorage.bind(null, LOCAL);
export const writeLocalStorageForUser = writeStorageForUser.bind(null, LOCAL);
export const removeLocalStorage = removeStorage.bind(null, LOCAL);
export const removeLocalStorageForUser = removeStorageForUser.bind(null, LOCAL);
export const readSessionStorage = readStorage.bind(null, SESSION);
export const readSessionStorageForUser = readStorageForUser.bind(null, SESSION);
export const writeSessionStorage = writeStorage.bind(null, SESSION);
export const writeSessionStorageForUser = writeStorageForUser.bind(null, SESSION);
export const removeSessionStorage = removeStorage.bind(null, SESSION);
export const removeSessionStorageForUser = removeStorageForUser.bind(null, SESSION);
